export default "__VITE_ASSET__a9f7355b__"